import { useState, useEffect, useRef } from 'react';

const faqData = [
  {
    question: 'O que é o Carta do Eu Futuro?',
    answer:
      'O Carta do Eu Futuro é uma plataforma que permite você escrever cartas para si mesmo no futuro. É uma ferramenta poderosa de autoconhecimento e transformação pessoal, baseada em técnicas de PNL e psicologia positiva.',
  },
  {
    question: 'Como funciona o envio das cartas?',
    answer:
      'Você escreve sua carta hoje e escolhe a data futura em que deseja recebê-la. No dia escolhido, enviamos sua carta por e-mail. É como uma cápsula do tempo digital que conecta você com seu eu futuro.',
  },
  {
    question: 'Minhas cartas são privadas?',
    answer:
      'Sim! Suas cartas são completamente privadas e criptografadas. Apenas você tem acesso ao conteúdo. Levamos sua privacidade muito a sério e nunca compartilhamos suas informações.',
  },
  {
    question: 'Posso escrever quantas cartas quiser?',
    answer:
      'No plano gratuito, você pode escrever até 3 cartas por mês. Nos planos pagos, você tem acesso ilimitado para escrever quantas cartas desejar, além de recursos exclusivos como templates personalizados.',
  },
  {
    question: 'Posso cancelar minha assinatura a qualquer momento?',
    answer:
      'Sim, você pode cancelar sua assinatura a qualquer momento sem custos adicionais. Suas cartas já programadas continuarão sendo enviadas normalmente até o fim do período pago.',
  },
  {
    question: 'Como funciona o Caderno de Gratidão?',
    answer:
      'O Caderno de Gratidão é uma ferramenta diária onde você registra momentos de gratidão. Estudos mostram que praticar gratidão regularmente aumenta a felicidade e reduz o estresse. Você recebe lembretes diários e pode acompanhar seu progresso.',
  },
  {
    question: 'Existe um aplicativo mobile?',
    answer:
      'Atualmente, nossa plataforma é otimizada para funcionar perfeitamente em navegadores mobile. Estamos desenvolvendo aplicativos nativos para iOS e Android que serão lançados em breve.',
  },
  {
    question: 'Como posso entrar em contato com o suporte?',
    answer:
      'Você pode entrar em contato conosco através do formulário de contato no site, por e-mail (contato@cartafuturo.org) ou através das nossas redes sociais. Respondemos todas as mensagens em até 24 horas.',
  },
];

const FAQAccordion = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const [visibleItems, setVisibleItems] = useState<number[]>([]);
  const itemRefs = useRef<(HTMLDivElement | null)[]>([]);

  useEffect(() => {
    const observers = itemRefs.current.map((ref, index) => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              setTimeout(() => {
                setVisibleItems((prev) => [...prev, index]);
              }, index * 100);
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1 }
      );

      if (ref) {
        observer.observe(ref);
      }

      return observer;
    });

    return () => {
      observers.forEach((observer) => observer.disconnect());
    };
  }, []);

  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-20 bg-luxury-ivory relative">
      {/* Decorative Line */}
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-400/20 to-transparent"></div>

      <div className="container mx-auto px-6 lg:px-16">
        <div className="max-w-4xl mx-auto">
          <div className="space-y-4">
            {faqData.map((faq, index) => {
              const isOpen = openIndex === index;
              const isVisible = visibleItems.includes(index);
              const isEven = index % 2 === 0;

              return (
                <div
                  key={index}
                  ref={(el) => (itemRefs.current[index] = el)}
                  className={`bg-cream-50 border border-gold-400/20 rounded-2xl overflow-hidden hover:border-gold-400/40 hover:shadow-gold transition-all duration-700 ${
                    isVisible
                      ? 'opacity-100 translate-y-0 translate-x-0'
                      : `opacity-0 translate-y-4 ${isEven ? '-translate-x-4' : 'translate-x-4'}`
                  }`}
                >
                  <button
                    onClick={() => toggleAccordion(index)}
                    className="w-full px-8 py-6 flex items-center justify-between text-left hover:bg-gold-400/5 transition-colors"
                  >
                    <span className="font-['Montserrat'] text-lg font-semibold text-luxury-black pr-4">
                      {faq.question}
                    </span>
                    <div
                      className={`w-8 h-8 flex items-center justify-center rounded-full bg-gold-400/10 flex-shrink-0 transition-transform duration-300 ${
                        isOpen ? 'rotate-180' : ''
                      }`}
                    >
                      <i className="ri-arrow-down-s-line text-gold-500 text-xl"></i>
                    </div>
                  </button>

                  <div
                    className={`overflow-hidden transition-all duration-500 ${
                      isOpen ? 'max-h-96' : 'max-h-0'
                    }`}
                  >
                    <div className="px-8 pb-6">
                      <div className="w-12 h-px bg-gradient-to-r from-gold-400/50 to-transparent mb-4"></div>
                      <p className="font-['Montserrat'] text-luxury-black/70 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Decorative Line */}
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-400/20 to-transparent"></div>
    </section>
  );
};

export default FAQAccordion;
